import { createSlice } from "@reduxjs/toolkit";

interface VaccinationState {
  shouldRefetch: boolean;
}

const initialState: VaccinationState = {
  shouldRefetch: false,
};

const vaccinationSlice = createSlice({
  name: "vaccination",
  initialState,
  reducers: {
    triggerRefetch: (state) => {
      state.shouldRefetch = true;
    },
    resetRefetch: (state) => {
      state.shouldRefetch = false;
    },
  },
});

export const { triggerRefetch, resetRefetch } = vaccinationSlice.actions;

export default vaccinationSlice.reducer;
